import React, { useEffect, useState } from "react";
import { Tabs, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import RDBProfile from "../RDBProfile";
import RDBResume from "../RDBResume";
import axios from "../../helper/axios";
import { useNavigate } from "react-router-dom";
import "./RDBDescription.scss";

function RDBDescription() {
  const [resumeResult, setResumeResult] = useState({});
  const resumeId = useParams().resumeID;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchResume = async () => {
      try {
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        const ownerId = userDetails.qhoid;
        const userId = userDetails.qhuid;
        const response = await axios.post(
          `/rdbsearchGetResume/${ownerId}/${userId}/${resumeId}`
        );
        console.log(response);

        setResumeResult(response.data.data);
      } catch (error) {
        console.error("Error fetching resume:", error);
      }
    };

    fetchResume();
  }, []);

  const items = [
    {
      key: "1",
      label: "Profile",
      children: <RDBProfile resumeResult={resumeResult} />,
    },
    {
      key: "2",
      label: "Resume",
      children: <RDBResume resumeResult={resumeResult} />,
    },
  ];
  return (
    <div className="rdb-description">
      <div className="rdb-description-back-btn">
        <Button style={{ border: "none" }} onClick={() => navigate(-1)}>
          <ArrowLeftOutlined />
        </Button>
      </div>
      <div className="rdb-description-container">
        <Tabs type="card" defaultActiveKey="1" items={items} />
      </div>
    </div>
  );
}

export default RDBDescription;
